<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <div class="pd-20px">
        <section class="has-text-left mgb-20px">
          <p
            class="has-text-link is-size-3 has-text-weight-bold mgb-20px has-text-centered">
            {{ $t('miseAJourTva.title')}}
          </p>
          <error-msg-component :messages="messagesPopup"
                               :error="isError"
                               :title="'miseAJourTva.error.title'"
                               :withEmplyFields="true"
                               @close="isError = $event"/>
          <div
            class="columns is-marginless is-paddingless card-content is-multiline is-gapless">
            <p class="column is-12 has-text-default is-size-6 has-text-weight-bold">
              {{$t('miseAJourTva.message')}}
            </p>
            <b-select class="column is-6 no-border-radius-right mgt-5px"
                      expanded v-model="tva">
              <option v-for="tva in regimeTva"
                      :key="tva.tauxTva"
                      :value="tva.tauxTva">
                {{ tva.tauxTva | formatPercent }}
              </option>
            </b-select>
          </div>
        </section>
        <div class="is-grouped pdt-20px">
          <button
            class="button btn-modal-annuler is-cancel pdh-20px"
            @click="$parent.close">
            {{$t('miseAJourTva.actions.cancel')}}
          </button>
          <button class="button is-addOrEdit mgl-10px pdh-20px"
                  @click="sendEvent()">
            {{$t('miseAJourTva.actions.validate')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    ligneRegroupement: Object,
  },
  data() {
    return {
      isError: false,
      messagesPopup: [],
      tva: 20,
    };
  },
  components: {
    errorMsgComponent,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    regimeTva() {
      return this.parametre(PARAMETRES_KEYS.regimeTva).filter((tva) => {
        return tva.actif || this.tva === tva.tauxTva;
      });
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    sendEvent() {
      this.messagesPopup = [];
      if (this.tva === null) {
        this.isError = true;
        this.messagesPopup.push({
          message: 'miseAJourTva.error.pourcentage',
        });
        return;
      }
      this.$emit('updateTva', this.tva);
      this.$parent.close();
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.regimeTva]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
